import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as me from '../../me'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * A {@link store.Feature} that manages employee check-ins for Summit
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor() {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'SummitCheckIn',
      selectors: () => new Selectors(this),
    })

    const meFeature = ngCore.inject(me.Feature)
    this.registerEffects(
      effects.clearFeedOnZoneChange(meFeature),
      effects.checkIfEligibleForDailyCheckIn(meFeature),
      effects.checkIfEligibleForDailyCheckInOnZoneChange(meFeature),
      effects.loadCheckIn(meFeature),
      effects.loadCheckInAfterGettingCurrentMood(),
      effects.submitResponse(meFeature),
      effects.loadFeed(meFeature),
      effects.startLoadOnViewIfNeeded(),
    )
  }
}
